/**
 * Created by Ivan on 11.03.2026
 */

const HungryGamesRewardWindow = Prefab.createWindow("hungry_games_reward_window", "hungrygamesrewardwindow_prefab_json");
